// Minimal, dependency-free renderer for the constrained markdown our AI tools emit
// (# / ## / ### headings, **bold**, and - bullets). Shared by Sermon + Prayer→Study.
function inline(text, keyBase) {
  const parts = text.split(/(\*\*[^*]+\*\*|\*[^*]+\*)/g).filter(Boolean);
  return parts.map((p, i) => {
    if (p.startsWith("**") && p.endsWith("**"))
      return <strong key={`${keyBase}-${i}`} className="text-white">{p.slice(2, -2)}</strong>;
    if (p.startsWith("*") && p.endsWith("*") && p.length > 2)
      return <em key={`${keyBase}-${i}`}>{p.slice(1, -1)}</em>;
    return <span key={`${keyBase}-${i}`}>{p}</span>;
  });
}

export default function MarkdownLite({ text }) {
  const lines = (text || "").split("\n");
  return (
    <div className="space-y-2">
      {lines.map((raw, i) => {
        const line = raw.trimEnd();
        if (!line.trim()) return null;
        if (line.startsWith("### ")) return <h4 key={i} className="text-lg text-white pt-2">{inline(line.slice(4), i)}</h4>;
        if (line.startsWith("## ")) return <h3 key={i} className="text-xl text-[#00E5FF] pt-3">{inline(line.slice(3), i)}</h3>;
        if (line.startsWith("# ")) return <h2 key={i} className="text-2xl text-white">{inline(line.slice(2), i)}</h2>;
        if (line.startsWith("- ")) return <div key={i} className="flex gap-2 pl-1"><span className="text-[#00E5FF] mt-0.5">•</span><span className="flex-1">{inline(line.slice(2), i)}</span></div>;
        return <p key={i} className="leading-relaxed">{inline(line, i)}</p>;
      })}
    </div>
  );
}
